import {createAsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit";
import AuthService from "./auth.service";

const access = localStorage.getItem("token");

interface ICredentials {
    username: string,
    password: string
}

export interface IClient {
    id: number
    name: string,
    embedConfig: {
        tokenId: string
        accessToken: string
        tokenExpiry: string
        reportConfig: {
            reportId: string
            reportName: string
            embedUrl: string
            datasetId: string
        }[]
    }
}

export interface IUser {
    clients: IClient[]
    name: string
}
export interface AuthState {
    access: string | null
    isLoggedIn: boolean
    user?: IUser
    currentClient?: IClient
}

export const login = createAsyncThunk(
    "auth/login",
    async (authData: ICredentials, thunkAPI) => {
        try {
            const data = await AuthService.login(authData.username, authData.password);
            return data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(null);
        }
    }
);

export const getUser = createAsyncThunk(
    "user/get",
    async () => {
        const data = await AuthService.getUser();
        return data;
    }
);

const initialState: AuthState = access
    ? {isLoggedIn: true, access}
    : {isLoggedIn: false, access: null};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        logout: (state) => {
            localStorage.removeItem("token");
            state.isLoggedIn = false;
            state.access = null;
        },
        setCurrentClient: (state, action: PayloadAction<IClient>) => {
            localStorage.setItem("currentClient", action.payload.id.toString())
            state.currentClient = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(login.fulfilled, (state, {payload}) => {
            state.isLoggedIn = true;
            state.access = payload;
        });
        builder.addCase(login.rejected, (state) => {
            state.isLoggedIn = false;
            state.access = null;
        })
        builder.addCase(getUser.fulfilled, (state, {payload}) => {
            state.user = payload;
        });
        builder.addCase(getUser.rejected, (state) => {
            state.user = undefined;
        })
    },
});

export const {logout, setCurrentClient} = authSlice.actions;
export default authSlice.reducer;

